import React, { FunctionComponent, SyntheticEvent } from 'react';
import { NavLink } from 'react-router-dom';
import presenter_icon from '../../assets/icons/presenter.svg';
import qanda_icon from '../../assets/icons/q_a.svg';
import poll_icon from '../../assets/icons/polls-bar.svg';
import attendees_icon from '../../assets/icons/attendees-icon.svg';
import { MIXPANEL_EVENT_IDENTIFIERS, MIXPANEL_EVENT_TYPES } from '../../constans/mixpanel-contants';
import { getMixpanelService } from '../../utils/services/mixpanel-service-instance';
import TransparentButton from '../shared/transparent-button/transparent-button';
import './header.scss';
import { getActivityAttendeeCountService } from '../../store/attendees-store/activity-attendee-count-service/activity-attendee-count-service-instance';
import { observer } from 'mobx-react-lite';
import { IPodiumFeatures, PodiumFeatures } from '../../constans/common-constants';

interface INavTab {
  url: string;
  toggleMobile: (event: SyntheticEvent<HTMLAnchorElement | HTMLDivElement | HTMLUListElement>) => void;
  isPodiumPollsEnabled?: boolean | null;
  isPodiumAttendeesEnabled?: boolean | null;
  isPodiumEnabled?: boolean | null;
  isQandaEnabled?: boolean | null;
  isPodiumSlidesEnabled?: boolean | null;
  isPodiumPresenterQuestionsEnabled?: boolean;
  getPreviewInformation?: () => Promise<void>;
  isMobile?: boolean;
}

export interface IButtonLink extends IPodiumFeatures {
  icon?: string;
  permissible?: boolean | null;
  mixpanelIdentity: MIXPANEL_EVENT_IDENTIFIERS;
}
const { PRESENTER, ATTENDEES, QANDA, POLLS } = PodiumFeatures;

const HeaderNavItems: FunctionComponent<INavTab> = ({
  url,
  toggleMobile,
  isPodiumEnabled,
  isQandaEnabled,
  isPodiumPollsEnabled,
  isPodiumAttendeesEnabled,
  isPodiumSlidesEnabled,
  getPreviewInformation,
  isPodiumPresenterQuestionsEnabled,
  isMobile
}): JSX.Element => {
  const headerNavs: IButtonLink[] = [
    {
      name: PRESENTER.name,
      title: PRESENTER.title,
      path: PRESENTER.path,
      icon: presenter_icon,
      permissible: isPodiumSlidesEnabled || isPodiumPresenterQuestionsEnabled,
      mixpanelIdentity: MIXPANEL_EVENT_IDENTIFIERS.PRESENTERS_TAB

    },
    {
      name: ATTENDEES.name,
      title: `${ATTENDEES.title} (${getActivityAttendeeCountService().activeAttendeeNumber})`,
      path: ATTENDEES.path,
      icon: attendees_icon,
      permissible: isPodiumAttendeesEnabled,
      mixpanelIdentity: MIXPANEL_EVENT_IDENTIFIERS.ATTENDEES_TAB
    },
    {
      name: QANDA.name,
      title: QANDA.title,
      path: QANDA.path,
      icon: qanda_icon,
      permissible: isQandaEnabled && isPodiumEnabled,
      mixpanelIdentity: MIXPANEL_EVENT_IDENTIFIERS.QATab,
    },
    {
      name: POLLS.name,
      title: POLLS.title,
      path: POLLS.path,
      icon: poll_icon,
      permissible: isPodiumPollsEnabled,
      mixpanelIdentity: MIXPANEL_EVENT_IDENTIFIERS.POLLS_TAB
    },
  ];

  const mixpanelTabHandler = (mixpanelIdentity: MIXPANEL_EVENT_IDENTIFIERS) => {
    getMixpanelService().track(mixpanelIdentity, MIXPANEL_EVENT_TYPES.CLICKED);
  };

  return (
    <ul onClick={toggleMobile} data-action="mobile-item">
      {headerNavs.map((tab, index) => {
        if (!tab.permissible) return;

        const iconName = `${tab.name}-icon`;
        return (
          <li key={index + tab.name}>
            <NavLink to={`${url}${tab.path}`} onClick={() => mixpanelTabHandler(tab.mixpanelIdentity)}>
              <img className={iconName} src={tab.icon} alt={iconName}/>
              <p>{tab.title}</p>
            </NavLink>
          </li>
        );
      })}
      <li>
        {isMobile && <TransparentButton onClick={getPreviewInformation} customClasses='preview-button'>Preview</TransparentButton>}
      </li>
    </ul>
  );
};

export default observer(HeaderNavItems);
